import { render } from "./WhyApplying.vue?vue&type=template&id=745a26dc&scoped=true"
import script from "./WhyApplying.vue?vue&type=script&lang=js"
export * from "./WhyApplying.vue?vue&type=script&lang=js"

import "./WhyApplying.vue?vue&type=style&index=0&id=745a26dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745a26dc"]])

export default __exports__